/**
 * Fixed, curated list of blog categories.
 *
 * Kept intentionally small and shared between the public frontend and the CMS
 * so editors pick from the same set — no free-text drift across articles.
 * Legacy values already stored in the database (from before this list existed)
 * still render correctly on the public site; only the CMS <select> is limited.
 */
export const BLOG_CATEGORIES = [
    "Custos & Orçamentos",
    "Guias",
    "Patologias",
    "Remodelação",
    "Materiais & Soluções",
    "Planeamento de Obra",
];
